module.exports = __webpack_public_path__ + "static/10-063821e60f8e1c8299017f64fa473cd4.jpg";